import apiHelpers from './apiHelpers';

export default {
    getOfferings(bundle_id) {
        return apiHelpers.httpRequest(`offerings/${bundle_id}`, {}, 'get');
    },
    deleteOfferingPage(bundle_id) {
        return apiHelpers.httpRequest(`offerings/${bundle_id}`, {}, 'delete');
    },
    addOfferings(bundle_id, body) {
        return apiHelpers.httpRequest(`offerings/${bundle_id}`, body, 'put');
    },
};